import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import Avatar from "@/components/Avatar";
import { usePlayerCard } from "@/context/PlayerCardContext";
import { toast } from "sonner";
import { UserPlus, UserCheck, Sparkles } from "lucide-react";

export default function SuggestedFollows() {
  const [sugs, setSugs] = useState([]);
  const [followed, setFollowed] = useState({});
  const { openPlayerCard } = usePlayerCard();

  useEffect(() => {
    api.get("/members/suggested").then(({ data }) => setSugs(data)).catch(() => {});
  }, []);

  const follow = async (u) => {
    setFollowed((f) => ({ ...f, [u.id]: true }));
    try {
      await api.post(`/members/${u.id}/follow`);
      toast.success(`Following ${u.name}`);
    } catch (e) {
      setFollowed((f) => ({ ...f, [u.id]: false }));
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  if (sugs.length === 0) return null;
  return (
    <div data-testid="suggested-follows" className="bg-pb-surface border border-pb-border p-5">
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="w-4 h-4 text-pb-cyan" />
        <h3 className="font-display font-bold uppercase text-sm tracking-wide">Suggested For You</h3>
        <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-600 ml-auto">Grow your circle</span>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-1 -mx-1 px-1" style={{ scrollbarWidth: "thin" }}>
        {sugs.map((u, i) => (
          <div key={u.id} data-testid={`suggested-${u.id}`}
            className="shrink-0 w-40 border border-pb-border/70 bg-pb-elevated/40 p-4 flex flex-col items-center text-center hover:border-pb-cyan/50 transition-colors animate-fade-up"
            style={{ animationDelay: `${i * 60}ms` }}>
            <button type="button" data-testid={`suggested-open-card-${u.id}`} onClick={() => openPlayerCard(u.id)}
              className="flex flex-col items-center w-full group">
              <Avatar src={u.avatar} name={u.name} size={52} />
              <div className="text-sm font-semibold mt-2 truncate w-full group-hover:text-pb-red transition-colors">{u.name}</div>
            </button>
            <div className="text-[10px] text-zinc-500 mt-0.5 line-clamp-2 h-7">{u.reason}</div>
            <button data-testid={`suggested-follow-${u.id}`} onClick={() => follow(u)} disabled={followed[u.id]}
              className={`mt-2 w-full flex items-center justify-center gap-1.5 text-[10px] font-black uppercase tracking-widest py-1.5 transition-all active:scale-95 ${
                followed[u.id] ? "border border-pb-cyan/50 text-pb-cyan" : "bg-pb-red text-black hover:bg-[#BEF264]"}`}>
              {followed[u.id] ? <><UserCheck className="w-3 h-3" /> Following</> : <><UserPlus className="w-3 h-3" /> Follow</>}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
